export const quoteState = {
  id: 0,
  first_name: 'John',
  showDiscountBanner: false,
}
